/**
 * Нормализует productsLink до path для catalog/redirect (например /brands/foo).
 */
export const normalizeCatalogRedirectUrl = (url) => {
  if (typeof url !== 'string') return ''

  const trimmed = url.trim()
  if (trimmed === '') return ''

  if (trimmed.startsWith('/')) return trimmed

  try {
    const parsed = new URL(trimmed)

    return `${parsed.pathname}${parsed.search}`
  } catch {
    return ''
  }
}

export const extractCatalogEntityId = (data) => data?.entityId ?? null
